{
  "global.siteDescription": "30秒で自分らしく自己紹介。あなたをすぐに知ってもらえます。",
  "global.languageSwitch": "言語を切り替える",
  "global.languageCurrent": "現在の言語: {locale}",
  "global.language.zh-CN": "简体中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "閉じる",
  "common.cancel": "キャンセル",
  "common.save": "保存",
  "common.delete": "削除",
  "common.edit": "編集",
  "common.manage": "管理",
  "common.login": "ログイン",
  "common.logout": "ログアウト",
  "common.loggingOut": "ログアウト中",
  "common.logoutRetry": "ログアウトを再試行",
  "common.preview": "プレビュー",
  "common.email": "Email",
  "common.inviteCode": "招待コード",
  "common.loading": "読み込み中",
  "editor.publish.processing": "引き続き処理中です",
  "common.localDraft": "ローカルドラフト",
  "common.publicBeta": "パブリックベータ",
  "common.serviceStatus": "サービス状況",
  "common.optional": "任意",
  "common.page": "ページ",
  "common.reason": "理由",
  "common.description": "詳細",
  "common.submit": "送信",
  "nav.login": "ログイン",
  "nav.draftFirst": "下書きから始める",
  "home.action.create": "自己紹介を作る",
  "home.action.continue": "続きを書く",
  "home.action.manage": "紹介を管理",
  "home.action.agent": "Agent に執筆を依頼",
  "home.meta.title": "30s.to — 30秒で、あなたを知ってもらう。",
  "home.meta.description": "一人で進むからこそ、自分を知ってもらうことが大切。30秒で、あなたを知ってもらう。あなたはどんな人で、今何に取り組み、これまで何をしてきたのか。提供できるリソースも伝えて、興味を持ってもらえるきっかけをつくり、つながりを広げましょう。",
  "home.title": "30秒で、\nあなたを知ってもらう。",
  "home.freeNote": "作成・公開・共有、ずっと無料。",
  "home.kicker": "一人で進むからこそ、自分を知ってもらうことが大切。",
  "home.value.copy": "あなたはどんな人で、今何に取り組み、これまで何をしてきたのか。提供できるリソースも伝えて、興味を持ってもらえるきっかけをつくり、つながりを広げましょう。",
  "home.features.label": "サービスの特徴",
  "home.features.time.tab": "30秒で読める",
  "home.why.copy": "いちばん大切なことだけを書く。自己紹介は、長いほど最後まで読まれません。30秒がちょうどいい。",
  "home.principle.expression.title": "自由に表現",
  "home.principle.expression.copy": "経験、作品、考え、リソースを自分らしくまとめて。知ってほしい自分を伝えましょう。",
  "home.principle.link.title": "あなた専用の30s.toリンク",
  "home.principle.link.copy": "30s.to/@youは短く、覚えやすく、意味もシンプル。30秒で、あなたを知る。",
  "home.principle.theme.title": "豊富なテーマで自分らしく",
  "home.principle.theme.copy": "すっきり、レトロ、大胆で鮮やか。自分らしいテーマを選んで、ひと目であなたの雰囲気が伝わる紹介に。",
  "home.footer.tagline": "少ない言葉だから、大切なことが伝わる。",
  "home.footer.navigation": "フッターナビゲーション",
  "home.demo.linkNotice": "これはサンプルリンクです。30秒プロフィールを作成すると、自分のリンクに変更できます。",
  "home.demo.profile.name": "マヤ・チェン",
  "home.demo.profile.identity": "複雑な問題をシンプルな製品に変える独立した製品デザイナー",
  "home.demo.profile.tag.product": "プロダクトデザイン",
  "home.demo.profile.tag.indie": "インディーズ製品",
  "home.demo.profile.tag.ai": "AI ツール",
  "home.demo.profile.body": "## 最近\n個人デザイナーがメモの整理より人の理解に時間を使えるよう、Brieflyを制作中です。設計前に利用者の作業をたどります。\n\n## これまでの経験\n2020〜2023年は共同作業ソフトのチームで、エディターと導入体験の設計を担当。複雑な操作をエンジニアと整理しました。\n\n2024年から独立。初期チームの利用者調査と操作設計を支援し、自分の小さな製品も育てています。\n\n## プロジェクト\n- [Relay](https://example.com/projects/relay)：設計を担当した意思決定記録ツール。結論、理由、担当者をまとめ、新しいメンバーにも背景が伝わります。\n- [Briefly](https://example.com/projects/briefly)：少人数で試用中の聞き取りメモツール。発言を残し、出典をたどれるテーマに整理して判断を確かめられます。\n\n## 共有できるもの\n利用者の声はあるけれど改善の優先順位に迷うチームへ、課題整理と検証用の試作を提供します。調査を始める方には、質問ガイドと記録テンプレートも共有できます。\n\n## 話しましょう\n小さな製品の作り手と、聞き取りや取捨選択、独立について話したいです。週末は街角の店へ。手書きの値札に、製品説明以上の発見があります。",
  "home.demo.profile.link.website": "ポートフォリオ",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "日程を調整",
  "handleStart.kicker": "公開URL",
  "handleStart.title": "30s.to のURLを選ぶ",
  "handleStart.copy": "覚えやすいURLを選んでから、30秒プロフィールを書きましょう。既存の下書きはそのまま引き継がれます。",
  "handleStart.label": "あなたのURL",
  "handleStart.help.empty": "英小文字4〜24文字。今は下書きに保存し、公開時に利用可能か確認します。",
  "handleStart.help.ok": "使用できる形式です。公開時にもう一度、利用可能か確認します。",
  "handleStart.submit": "プロフィールを書く",
  "handleAvailability.checking": "このURLを確認しています…",
  "handleAvailability.available": "現在利用できます。公開が完了すると、あなたのURLになります。",
  "handleAvailability.owned": "あなたが現在所有しているURLです。",
  "handleAvailability.assigned": "あなたに割り当てられたURLです。公開が完了すると有効になります。",
  "handleAvailability.failed": "URLの状態を確認できませんでした。もう一度お試しください。",
  "handleAvailability.rateLimited": "確認回数が多すぎます。{minutes}分後にもう一度お試しください。",
  "handleAvailability.retry": "もう一度確認",
  "handleAvailability.suggestions": "こちらも試せます",
  "handleAvailability.cooldown": "公開URLは30日間の変更待機期間中です。{date}以降に再度変更できます。現在公開中のURLに戻すこともできます。",
  "editor.shell.loading": "作成フローを読み込み中",
  "editor.shell.workspace": "30 秒のイントロ ワークスペース",
  "editor.shell.canvas": "30 秒のイントロ書き込み面",
  "editor.command.aria": "エディタのコマンドバー",
  "editor.command.publish": "公開",
  "editor.command.publishUpdate": "変更を公開する",
  "editor.command.publishSettings": "設定の公開",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "発行済み",
  "editor.publish.successAfterLogin": "ログインして公開しました",
  "editor.publish.publishing": "公開中…",
  "editor.publish.publishingDetail": "公開ページを準備しています。しばらくお待ちください。",
  "editor.publish.successDetail": "公開ページを更新しました。今すぐ確認できます。",
  "editor.publish.viewPublic": "公開ページを見る",
  "editor.publish.cacheFailed": "しかし、パブリックページキャッシュの書き込みは失敗しました。",
  "editor.command.login": "ログイン",
  "editor.handle.editTitle": "パブリックアドレスを編集する",
  "editor.handle.claimAfterPublish": "公開後のあなたのもの",
  "editor.handle.claimAfterPublishTitle": "このアドレスは公開後にあなたのものになります",
  "editor.status.signedIn": "サインインしました",
  "editor.status.account": "アカウント: {email}",
  "editor.status.localTitle": "ローカルドラフト",
  "editor.status.localCopy": "この下書きはこのデバイスにのみ保存されます。サインインしてクラウドに同期します。",
  "editor.status.location": "場所を保存する",
  "editor.status.state": "ステータスの保存",
  "editor.status.emailLogin": "Email ログイン",
  "editor.autosave.savingShort": "保存",
  "editor.autosave.savedCloudShort": "クラウドに保存",
  "editor.autosave.savedLocalShort": "ローカルに保存されました",
  "editor.autosave.failedShort": "保存に失敗しました",
  "editor.autosave.signedInShort": "サインインしました",
  "editor.autosave.cloud": "雲",
  "editor.autosave.retry": "再試行が必要です",
  "editor.autosave.device": "このデバイス",
  "editor.autosave.saving": "自動保存中...",
  "editor.autosave.savedLocal": "ローカルに自動保存",
  "editor.autosave.savedCloud": "クラウドに自動保存される",
  "editor.autosave.authExpired": "セッションの有効期限が切れました。ローカルに保存されました。",
  "editor.autosave.cloudFailed": "クラウド保存に失敗しました。ローカルに保存されました。",
  "editor.autosave.cloudUnavailable": "クラウド保存はまだ接続されていません。ローカルに保存されました。",
  "editor.autosave.failed": "自動保存に失敗しました。コンテンツをコピーして再試行してください。",
  "editor.autosave.enabled": "自動保存がオンになっています",
  "identity.namePlaceholder": "あなたの名前",
  "identity.nameAria": "名前またはニックネーム",
  "identity.identityPlaceholder": "一行のアイデンティティ",
  "identity.identityAria": "一行のアイデンティティ",
  "identity.tagsAria": "タグ",
  "identity.addTag": "タグを追加",
  "identity.removeTag": "タグ {tag} を削除します",
  "body.emptyInstruction": "初めて会う人に知ってほしい大切なことを書きましょう。\n少し短く。大切なことほど、読んでもらえます。30秒がちょうどいい。",
  "body.templatesLabel": "テンプレートから始めることもできます",
  "body.templatesAria": "本文の立場別テンプレート",
  "body.templateExampleLabel": "サンプルプロフィール",
  "body.viewTemplateExample": "例を見る",
  "links.sectionAria": "リンク",
  "links.documentTitle": "リンク",
  "links.documentCopy": "ソーシャルプロフィール、予約、連絡先の詳細",
  "links.documentEmptyCopy": "ソーシャル プロフィール、予約ページ、または連絡方法を追加します。いつでも変更できます。",
  "links.add": "リンクを追加",
  "links.addType": "{label}を追加",
  "links.edit": "{label}を編集",
  "links.addedAria": "リンクを追加しました",
  "links.closePanel": "リンクエディタを閉じる",
  "links.editTitle": "リンクを編集",
  "links.addTitle": "リンクを追加",
  "links.chooseTypeAgain": "リンクタイプを再度選択してください",
  "links.calendarProvider": "予約プロバイダー",
  "links.displayName": "表示名",
  "links.duplicate": "{label} はすでに追加されています。",
  "links.alreadyAdded": "{label} はすでに追加されています",
  "links.bookingAlreadyAdded": "予約はすでに追加されています",
  "links.remove": "消去",
  "links.category.social": "社交",
  "links.category.booking": "予約",
  "links.category.work": "作品 / ウェブサイト",
  "links.category.content": "コンテンツ",
  "links.category.contact": "接触",
  "links.category.other": "他の",
  "links.type.x": "×",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "小紅書",
  "links.type.wechat": "WeChat公式アカウント",
  "links.type.email": "Email",
  "links.type.calendar": "予約",
  "links.type.website": "ウェブサイト",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "寺家",
  "links.type.other": "他の",
  "links.input.x": "Xのユーザー名",
  "links.input.github": "GitHubのユーザー名",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Instagramのユーザー名",
  "links.input.youtube": "YouTubeのユーザー名",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "小紅書 プロフィール URL",
  "links.input.wechat": "WeChat公式アカウントID",
  "links.input.email": "Email",
  "links.input.calendar": "予約パス",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "TikTokのユーザー名",
  "links.input.threads": "Threadsのユーザー名",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Dribbbleのユーザー名",
  "links.input.jike": "ジーク プロフィール URL",
  "links.input.other": "リンク URL",
  "links.input.calendar.cal": "Cal.com パス",
  "links.input.calendar.calendly": "淡々とした道",
  "links.input.calendar.google": "Google Calendar 予約ページ",
  "links.input.calendar.microsoft": "Microsoft Bookingsリンク",
  "links.input.calendar.hubspot": "HubSpot Meetingsリンク",
  "links.input.calendar.savvycal": "SavvyCal パス",
  "links.input.calendar.tidycal": "TidyCal パス",
  "links.input.calendar.zcal": "zcal パス",
  "links.hint.handle": "URLではなく、ユーザー名だけを入力してください。",
  "links.hint.uid": "プロファイル URL ではなく、UID のみを入力します。",
  "links.hint.slug": "完全な URL ではなく、パスのみを入力します。",
  "links.hint.email": "これにより、mailto リンクが作成されます。",
  "links.hint.text": "公開ページをクリックすると、この値がコピーされます。",
  "links.hint.url": "このプラットフォームの有効な https:// リンクを入力してください。",
  "links.hint.calendarSlug": "完全な URL ではなく、ユーザー名または予約パスのみを入力してください。",
  "links.hint.calendarUrl": "このプラットフォームの完全な予約ページ URL を入力してください。",
  "rich.toolbarAria": "本文の書式設定ツールバー",
  "rich.heading": "セクションの見出し",
  "rich.paragraph": "段落",
  "rich.bold": "大胆な",
  "rich.boldFallback": "太字のテキスト",
  "rich.italic": "イタリック",
  "rich.italicFallback": "斜体のテキスト",
  "rich.code": "インラインコード",
  "rich.comment": "コメントを切り替える",
  "rich.ul": "箇条書きリスト",
  "rich.ol": "番号付きリスト",
  "rich.link": "リンク",
  "rich.linkPrompt": "https:// または mailto: リンクを入力してください",
  "rich.linkInvalid": "リンクは https:// または mailto のみをサポートします。",
  "rich.linkFallback": "リンクテキスト",
  "rich.aria": "30秒のイントロ本文",
  "rich.more": "その他の書式",
  "rich.quote": "引用",
  "rich.strikethrough": "取り消し線",
  "rich.strikethroughFallback": "取り消し線のテキスト",
  "rich.codeBlock": "コードブロック",
  "rich.codeBlockFallback": "コード",
  "rich.taskList": "タスクリスト",
  "rich.table": "表",
  "rich.tableSkeleton": "| 項目 | 説明 |\n| --- | --- |\n| 項目1 | 説明1 |\n| 項目2 | 説明2 |",
  "rich.indent": "インデントを増やす",
  "rich.outdent": "インデントを減らす",
  "rich.placeholder": "30 秒で読める Markdown のイントロを書いてください...",
  "feedback.aria": "フィードバックを書く",
  "feedback.timeTitle": "推定読書時間",
  "feedback.preview": "プレビュー",
  "feedback.previewMenu": "プレビューメニューを開く",
  "feedback.openAcceptancePreview": "受け入れプレビューを開く",
  "feedback.acceptancePreviewCopy": "このデバイスで公開ページの結果を表示する",
  "feedback.noIssues": "ブロッキングの問題はありません",
  "feedback.prePublish": "公開前チェック",
  "feedback.ready": "ブロッカーなし",
  "feedback.itemCount": "{count} アイテム",
  "feedback.valid": "コンテンツは公開チェックに合格します。",
  "issue.action.displayName": "名前を追加",
  "issue.action.oneLineIdentity": "ID を追加する",
  "issue.action.tags": "タグを追加する",
  "issue.action.body": "本文に戻る",
  "issue.action.handle": "公開URLを選んでください",
  "issue.action.links": "リンクの管理",
  "issue.action.view": "ビュー",
  "issue.short.displayName": "名前がありません",
  "issue.short.oneLineIdentity": "アイデンティティの喪失",
  "issue.short.tags": "タグがありません",
  "issue.short.handle": "公開URLが未設定です",
  "issue.short.readingTime": "60秒超",
  "issue.short.readingTimeLong": "30秒超",
  "issue.short.readingTimeShort": "内容が少なすぎる",
  "issue.short.bodyPlaceholder": "本文プレースホルダ",
  "issue.short.bodyFormat": "本文フォーマット",
  "issue.short.links": "リンクの問題",
  "issue.short.linksEmpty": "リンクを追加できます",
  "issue.short.pending": "仕事が必要です",
  "issue.summary.more": "{count} 修正すべき項目",
  "publish.title.create": "公開の確認",
  "publish.title.update": "変更を確認する",
  "publish.action.create": "30s.to に公開",
  "publish.action.update": "変更を公開する",
  "publish.closeAria": "公開確認を閉じる",
  "publish.address": "パブリックアドレス",
  "publish.unpublishedChanges": "未公開の変更",
  "publish.handleChanged": "公開アドレスを @{oldHandle} から @{newHandle} に変更します。旧アドレスは30日間転送され、変更から180日後には他の人に再割り当てされる可能性があります。古いリンクに別の人の紹介が表示されることがあります。",
  "publish.readingTime": "読書時間",
  "publish.status": "状態",
  "publish.ready": "準備ができて",
  "publish.todo": "{count} 改善すべき項目",
  "publish.visibility": "公開範囲",
  "publish.visibility.indexed": "検索エンジンへの登録を許可",
  "publish.visibility.unlisted": "リンク限定公開",
  "publish.visibility.indexedNote": "誰でも閲覧でき、検索結果に表示される場合があります。",
  "publish.visibility.unlistedNote": "リンクを知っている人は誰でも閲覧できます。検索エンジンにはこちらから登録しません。",
  "publish.visibility.publicNote": "どちらも公開ページで、リンクは転送できます。自分だけで見る場合は下書きのままにしてください。",
  "publish.publicContent": "公開すると、名前、肩書き、タグ、本文、リンクが一般公開されます。作者コメントは表示されませんが、秘密情報は保存しないでください。",
  "publish.noop": "公開ページはすでに最新のものになっています。再度公開する前に、コンテンツまたは公開範囲を変更してください。",
  "publish.valid": "コンテンツは公開チェックに合格します。",
  "handleEdit.title": "パブリックアドレスを編集する",
  "handleEdit.label": "30s.toアドレス",
  "handleEdit.help.changed": "保存は下書きのみを変更します。公開後、旧アドレスは30日間転送され、180日後には再割り当てされる可能性があります。",
  "handleEdit.help.saved": "下書きに保存されました。公開時に可用性が再度チェックされます。",
  "handleEdit.note": "現在のパブリック アドレスは依然として 30s.to/@{handle} です。新しいアドレスは公開後に有効になります。",
  "handleEdit.save": "下書きに保存",
  "conflict.title": "ドラフトバージョンを選択してください",
  "conflict.copy": "このデバイスとクラウドの両方に未公開のコンテンツがあります。選択した内容が、次に編集するバージョンになります。",
  "conflict.useLocal": "ローカルドラフトを使用する",
  "conflict.useLocalCopy": "現在のページのコンテンツを保持し、クラウドに同期します。",
  "conflict.useCloud": "雲のドラフトを使用する",
  "conflict.untitled": "無題",
  "conflict.cloudVersion": "クラウドに保存されたバージョン",
  "conflict.modifiedAt": "最終更新 · {time}",
  "conflict.time.justNow": "たった今",
  "conflict.time.minutesAgo": "{count}分前",
  "conflict.time.hoursAgo": "{count}時間前",
  "conflict.time.daysAgo": "{count}日前",
  "authModal.title": "30s.toにログインします",
  "authModal.copy": "ログイン後、下書きはクラウドに同期され、公開の信頼性が高まります。",
  "login.page.eyebrow": "アカウント",
  "login.page.title": "30s.toにログインします",
  "login.page.copy": "下書きを同期し、公開ページを公開し、招待を管理します。",
  "login.invalidEmail": "有効な電子メールを入力してください。",
  "login.sendFailed": "コードを送信できませんでした。",
  "login.devCodeReady": "ローカル開発コードが生成されました。",
  "login.codeSent": "コードが送信されました。メールを確認してください。",
  "login.networkSendFailed": "コードを送信できませんでした。接続を確認してください。",
  "login.invalidCode": "6桁のコードを入力してください。",
  "login.codeInvalid": "コードが間違っているか、有効期限が切れています。",
  "login.failed": "ログインに失敗しました。後でもう一度試してください。",
  "login.sendBusy": "送信中...",
  "login.resendCode": "コードを再送信する",
  "login.sendCode": "コードを送信する",
  "login.localCode": "ローカル開発コード: {code}",
  "login.code": "コード",
  "login.codePlaceholder": "6桁",
  "login.inviteHelp": "パブリックベータ版には招待コードが必要です。認証によりアカウントが有効になります。",
  "login.verifyBusy": "確認中...",
  "login.verifyInvite": "招待を確認してログイン",
  "login.verify": "ログインして続行",
  "login.footnote": "パスワードなしのログイン。新規ユーザーはメール認証後に招待を使用してアクティベートします。",
  "login.google": "Google を続ける",
  "login.github": "GitHub を続ける",
  "login.emailDivider": "または電子メールを使用する",
  "login.oauthFailed": "ソーシャルログインが完了しませんでした。もう一度試すか、電子メール ログインを使用してください。",
  "login.linkTitle": "アカウントのメールアドレスを確認する",
  "login.linkPageCopy": "30s.to アカウントはすでにこのメールを使用しています。確認後にのみリンクします。アカウントが自動的に統合されることはありません。",
  "login.linkCopy": "コードを{email}に送信します。ここでメールアドレスを変更することはできません。",
  "login.linkVerify": "確認してリンクする",
  "login.linkRequired": "既存のアカウントが見つかりました。続行するには電子メールを確認してください。",
  "login.activateTitle": "30s.toをアクティブ化する",
  "login.activatePageCopy": "あなたの社会的アイデンティティが確認されます。招待が成功するまで、永久アカウントは作成されません。",
  "login.activateCopy": "パブリックベータ版には招待が必要です。アカウントの作成が成功した場合にのみ引き換えられます。",
  "login.activationOpenCopy": "現在は登録を開放しています。続行するとアカウントが有効になります。",
  "login.activationClosedCopy": "現在、新しいアカウントの有効化は停止中です。既存のアカウントは引き続きログインできます。",
  "login.activate": "アクティブ化して続行する",
  "login.inviteRequired": "Emailで確認しました。招待を使用してアクティブ化します。",
  "login.useEmailInstead": "代わりに電子メールログインを使用してください",
  "preview.emptyEyebrow": "プレビュー",
  "preview.emptyTitle": "プレビューできるイントロはありません。",
  "preview.backToEdit": "編集に戻る",
  "preview.edit": "編集",
  "preview.localNoteAria": "ローカルプレビューメモ",
  "preview.localNote": "現地での受け入れ",
  "preview.localTitle": "このデバイスでの下書きプレビュー",
  "preview.themePicker": "テーマスイッチャー",
  "preview.themeGroup": "テーマを選択してください",
  "preview.themeFree": "ベース",
  "preview.themePro": "プロ",
  "preview.mobileAria": "モバイル公開ページのプレビュー",
  "preview.close": "プレビューを閉じる",
  "preview.editorTitle": "プレビュー",
  "preview.publicTitle": "公開ページのプレビュー",
  "preview.shareCardButton": "テーマカードを見る",
  "preview.shareCardDialogTitle": "テーマカードのプレビュー",
  "preview.shareCardTitle": "{theme}テーマカード",
  "preview.shareCardLogin": "サインインして実際のプレビューをレンダリングする",
  "preview.shareCardLoading": "テーマカードをレンダリング中…",
  "preview.shareCardError": "カードのプレビューは一時的に利用できません",
  "preview.shareCardNote": "テーマ カードは、公開ページと同じビジュアル言語を使用します。ユニバーサル カードは Dashboard で使用できます。",
  "public.copySuccess": "{label}をコピーしました",
  "public.copyFailed": "コピーに失敗しました。手動でコピーしてください。",
  "public.createMine": "私の紹介文を作成する",
  "public.report": "このページを報告する",
  "public.ownerAria": "個人管理エントリー",
  "public.owner.manage": "管理",
  "public.owner.edit": "編集",
  "public.status.unavailable": "利用不可",
  "public.status.notFound": "404",
  "public.status.moderated": "この 30 秒のイントロは利用できません。",
  "public.status.frozen": "このパブリック アドレスは利用できません。",
  "public.status.unpublished": "この 30 秒のイントロはまだ公開されていません。",
  "theme.footer": "30s.toで作られました",
  "theme.fallback.name": "あなたの名前",
  "theme.fallback.nameUpper": "あなたの名前",
  "theme.fallback.nameNoir": "名前",
  "theme.fallback.nameIndex": "ジョン・ドゥ",
  "theme.fallback.identity": "職業はなんですか？",
  "theme.fallback.identityUpper": "あなたのワンラインのアイデンティティと使命",
  "theme.fallback.identityIndex": "未知",
  "theme.fallback.identityNoir": "身元",
  "theme.fallback.terminalName": "ゲスト",
  "theme.fallback.terminalIntro": "短いイントロはまだありません",
  "theme.terminal.commandLabel": "ターミナルコマンド",
  "theme.terminal.commandSubmit": "コマンドの実行",
  "theme.terminal.outputLabel": "インタラクティブ端末出力",
  "theme.connect": "接続する",
  "theme.markdown.tableRegion": "本文の表、横方向にスクロール可能",
  "theme.markdown.task": "タスク",
  "theme.tags": "タグ",
  "theme.verified": "確認済み",
  "theme.name": "名前",
  "theme.identityLabel": "身元",
  "theme.keywords": "キーワード",
  "theme.scroll": "スクロール",
  "theme.pixel.previous": "前の画面",
  "theme.pixel.next": "次の画面",
  "theme.pixel.screen": "{total}の画面{current}",
  "theme.arcade.stage": "ステージ {current} / {total}",
  "theme.noise.reseed": "再シードノイズ",
  "theme.readingTime": "約{seconds}秒で読めます",
  "theme.readingUnit": "秒で読める",
  "theme.letter.greeting": "はじめまして。",
  "theme.letter.signoff": "どうぞよろしく。",
  "theme.letter.postscript": "連絡先はこちら",
  "theme.letter.written": "{date} 記",
  "dashboard.loginTitle": "ログインして紹介文を管理します。",
  "dashboard.loginAction": "ログインして管理する",
  "dashboard.bannedTitle": "このアカウントは現在利用できません。",
  "dashboard.bannedCopy": "これが間違いであると思われる場合は、レポートと異議申し立てのエントリを通じてご連絡ください。",
  "connections.kicker": "アカウント",
  "connections.title": "ログイン方法",
  "connections.settingsKicker": "設定",
  "connections.settingsTitle": "アカウントと接続",
  "connections.settingsCopy": "ログインIDとサードパーティAgentの権限を管理します。",
  "connections.backToDashboard": "管理ページに戻る",
  "connections.emailCode": "メール認証コード",
  "connections.alwaysAvailable": "常に利用可能",
  "connections.connect": "接続する",
  "connections.disconnect": "30s.to リンクを削除",
  "connections.notConnected": "接続されていません",
  "connections.noEmail": "電子メールが提供されていません",
  "connections.emailVerified": "Email 確認済み",
  "connections.connected": "接続済み",
  "connections.unavailable": "有効になっていません",
  "connections.confirm": "30s.to から {provider} リンクを削除しますか? Email ログインは引き続き利用可能です。",
  "connections.removed": "ID リンクが 30s.to から削除されました。",
  "connections.failed": "ログイン方法を更新できませんでした。後でもう一度試してください。",
  "connections.help": "これにより削除されるのは、30s.to ID マッピングのみです。プロバイダーのアクセスは取り消されません。プロバイダーのアクセスを管理します。",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Agent 接続",
  "agentConnections.copy": "1つのSkillをインストールし、普段使うAgentに情報収集、文章作成、30s.to下書きの安全な更新を任せます。",
  "agentConnections.addTitle": "新しいAgentを接続",
  "agentConnections.addCopy": "接続URLと設定手順を表示",
  "agentConnections.examplesDisclosure": "使用例を見る",
  "settings.title": "設定",
  "settings.copy": "アカウント、セキュリティ、外部接続、30s.toのプランを管理します。",
  "settings.navAria": "設定カテゴリー",
  "settings.account.title": "アカウント",
  "settings.account.copy": "30s.toでのあなたのIDとプロフィールへの入口です。",
  "settings.account.email": "アカウントのメール",
  "settings.account.profile": "プロフィール",
  "settings.account.plan": "現在のプラン",
  "settings.account.manageProfile": "プロフィールを管理",
  "settings.login.copy": "30s.toへのログインに使用できるIDを管理します。",
  "settings.billing.copy": "現在のプラン、更新状況、請求情報へのアクセスを確認します。",
  "settings.invites.copy": "Public Betaの招待枠と最近の招待コードを管理します。",
  "agentConnections.endpoint": "接続 URL",
  "agentConnections.copyAction": "コピー",
  "agentConnections.copied": "コピー済み",
  "agentConnections.copyFailed": "コピーできませんでした。URL を手動でコピーしてください。",
  "agentConnections.endpointCopied": "接続 URL をコピーしました。",
  "agentConnections.stepsAria": "Agent の接続手順",
  "agentConnections.step1": "Agent の MCP またはコネクター設定でリモートサービスを追加します。",
  "agentConnections.step2": "接続 URL を貼り付け、30s.to にログインしてアクセスを許可します。",
  "agentConnections.step3": "変更内容を Agent に伝え、完了後に 30s.to で下書きを確認します。",
  "agentConnections.examplesTitle": "依頼例",
  "agentConnections.exampleFirst": "30s.to のプロフィールと書式ルールを読み、最初の自己紹介を仕上げてください。",
  "agentConnections.exampleSection": "今の文体を保ち、「現在」のセクションだけを書き直してください。",
  "agentConnections.exampleShorten": "全文を 30 秒以内で読める長さにしてください。公開はしないでください。",
  "agentConnections.copyExample": "例 {number} をコピー",
  "agentConnections.promptCopied": "依頼例をコピーしました。",
  "agentConnections.boundary": "Agent ができるのは下書きの読み取りと更新だけです。公開や公開停止はできません。",
  "agentConnections.authorizedTitle": "許可済みの接続",
  "agentConnections.empty": "許可済みの Agent 接続はありません。",
  "agentConnections.disabled": "Agent 接続はまだ有効ではありません。",
  "agentConnections.scopeRead": "下書きを読み取る",
  "agentConnections.scopeWrite": "下書きを更新",
  "agentConnections.connectedAt": "{date} に接続",
  "agentConnections.selfReported": "クライアント名はクライアントによる自己申告です",
  "agentConnections.revoke": "取り消す",
  "agentConnections.confirm": "{client} との接続を取り消しますか？このクライアントは30s.toの下書きにアクセスできなくなります。",
  "agentConnections.confirmSkill": "30s.to Skillの接続を取り消しますか？このSkillを使用するローカルAgentは30s.toからログアウトします。",
  "agentConnections.revoked": "Agent 接続を取り消しました。",
  "agentConnections.failed": "Agent 接続を更新できませんでした。後でもう一度お試しください。",
  "agentConnections.manualTitle": "Remote MCPを手動接続",
  "agentConnections.manualCopy": "上級者向け：Remote MCP対応クライアントを個別に認可",
  "skill.meta.title": "30s.to Skill — Agentに30秒の紹介を書いてもらう",
  "skill.meta.description": "サイトやプロジェクト、作品のリンクを共有。Agentが調査とインタビューを通じて、30秒の自己紹介を書きます。",
  "skill.kicker": "30s.to Skill",
  "skill.title": "自己紹介は、\nいつものエージェントと。",
  "skill.copy": "リンクをいくつか渡すだけ。エージェントがあなたを調べ、30秒で読める自己紹介にまとめます。",
  "skill.processTitle": "Agentが書くまで",
  "skill.process.clues.title": "リンクを送る",
  "skill.process.clues.copy": "公開プロフィール、プロジェクトのサイト、ポートフォリオ。",
  "skill.process.research.title": "じっくり調べてから、インタビュー",
  "skill.process.research.copy": "サイトやプロジェクト、作品を詳しく調べて要点を整理し、資料だけでは分からないことをインタビューで補います。",
  "skill.process.profile.title": "自己紹介を書き上げる",
  "skill.process.profile.copy": "内容や語り口を一緒に調整し、自分らしい紹介に仕上げます。",
  "skill.installTitle": "Agentにインストール",
  "skill.installCopy": "指示をコピーし、いつものエージェントに貼り付けて送信します。",
  "skill.promptLabel": "インストール指示",
  "skill.copyPrompt": "インストール指示をコピー",
  "skill.promptCopied": "インストール指示をコピーしました。次に、普段使っているAgentを開き、貼り付けて送信してください。",
  "skill.copyFailed": "コピーできませんでした。下のインストール指示を選択してコピーしてください。",
  "skill.startTitle": "はじめ方",
  "skill.start.install": "30s.to Skill をインストール",
  "skill.start.chat": "話しはじめる",
  "skill.start.chatCopy": "インストール後、新しい会話でこう伝えます：",
  "skill.start.prompt": "30s.to で自己紹介を書くのを手伝って。",
  "dashboard.kicker": "私の紹介",
  "dashboard.defaultTitle": "私の30秒のイントロ",
  "dashboard.primaryEdit": "編集を続ける",
  "dashboard.primaryCreate": "作成を開始する",
  "dashboard.unpublished": "非公開",
  "dashboard.unselected": "未選択",
  "dashboard.confirmDiscard": "未公開の変更を破棄し、現在の公開バージョンを復元しますか?",
  "dashboard.discardFailed": "変更を破棄できませんでした。",
  "dashboard.discardConflict": "この下書きは別の場所で更新されました。ページを再読み込みして確認してから、もう一度お試しください。",
  "dashboard.discardNetworkFailed": "変更を破棄できませんでした。後でもう一度試してください。",
  "dashboard.discardDone": "現在の公開バージョンに復元されました。",
  "dashboard.statusAria": "現在の状況",
  "dashboard.versionAria": "バージョン関係",
  "dashboard.publicPage": "公開ページ",
  "dashboard.indexingAllowed": "検索登録を許可",
  "dashboard.indexingBlocked": "リンク限定公開",
  "dashboard.publicVersion": "公開バージョン",
  "dashboard.invisible": "まだ他の人には表示されていません",
  "dashboard.draft": "下書き",
  "dashboard.currentDraft": "現在編集可能なバージョン",
  "dashboard.draftSynced": "公開ページと同期しました",
  "dashboard.editableVersionEmpty": "編集可能なバージョン · 作成されていません",
  "dashboard.editableVersionDirty": "編集可能なバージョン · 変更は公開されません",
  "dashboard.editableVersionSynced": "編集可能なバージョン · 公開ページと一致する",
  "dashboard.editableVersionUnpublished": "編集可能なバージョン · 公開されていません",
  "dashboard.betaActive": "アクティブ",
  "dashboard.betaInactive": "非アクティブ",
  "dashboard.adminCanPublish": "管理者アカウントで公開可能",
  "dashboard.betaAccessNote": "パブリックベータ公開アクセス",
  "dashboard.visibility": "公開範囲",
  "dashboard.chooseOnPublish": "公開確認時に選択してください",
  "dashboard.snapshot": "スナップショット",
  "dashboard.snapshotAfterPublish": "公開ページのスナップショットは公開後に生成されます",
  "dashboard.publishDetailsAria": "出版詳細",
  "dashboard.actionsAria": "管理アクション",
  "dashboard.nextAction": "次のステップ",
  "dashboard.openPublicPage": "公開ページを開く",
  "dashboard.changeVisibility": "公開範囲を変更",
  "dashboard.unpublish": "公開を停止",
  "dashboard.unpublishTitle": "公開を停止しますか？",
  "dashboard.unpublishDescription": "公開ページはすぐに閲覧できなくなります。下書きと公開アドレスは保持され、後で再公開できます。",
  "dashboard.unpublishWarning": "検索エンジンや他の人が保存したコピーは、すぐには消えない場合があります。",
  "dashboard.unpublishConfirm": "公開を停止",
  "dashboard.unpublishBusy": "停止しています...",
  "dashboard.unpublishSuccess": "公開ページを停止しました。下書きと公開アドレスは保持されています。",
  "dashboard.unpublishFailed": "公開を停止できませんでした。後でもう一度お試しください。",
  "dashboard.discardBusy": "復元中...",
  "dashboard.discard": "変更を破棄する",
  "dashboard.metricsAria": "軽量データ",
  "dashboard.views": "ビュー",
  "dashboard.clicks": "クリック数",
  "dashboard.readingTime": "読書時間",
  "dashboard.theme": "テーマ",
  "dashboard.noTheme": "未選択",
  "dashboard.visibility.indexed": "検索エンジンへの登録を許可",
  "dashboard.visibility.unlisted": "リンク限定公開",
  "dashboard.visibility.indexedNote": "検索結果に表示される場合があります",
  "dashboard.visibility.unlistedNote": "直接リンクを知っている人は引き続き閲覧できます",
  "dashboard.snapshot.ready": "キャッシュの準備完了",
  "dashboard.snapshot.failed": "D1 フォールバック",
  "dashboard.snapshot.none": "生成されない",
  "dashboard.snapshot.readyNote": "KV に書き込まれたパブリック スナップショット",
  "dashboard.snapshot.failedNote": "公開ページは D1 フォールバックを通じて引き続き機能します",
  "dashboard.snapshot.noneNote": "現在公開されているバージョンで使用できるスナップショットはありません",
  "invite.title": "友達をパブリックベータに招待する",
  "invite.remaining": "今月は {remaining} / {quota} の招待状が残っています。",
  "invite.generateFailed": "招待状を生成できませんでした。",
  "invite.generated": "{count} 個の招待コードを生成しました。表示は今回限りです。",
  "invite.quotaUsed": "毎月の招待割り当てが使用されました。",
  "invite.generating": "生成中...",
  "invite.generate": "残り {count} 個をまとめて生成",
  "invite.batchTitle": "今回生成した {count} 個の招待コード",
  "invite.copyAll": "コードをすべてコピー",
  "invite.copiedAll": "すべてのコードをコピーしました",
  "invite.copyMessage": "シェア文をコピー",
  "invite.messageCopied": "シェア文をコピーしました",
  "invite.share": "直接シェア",
  "invite.shared": "共有画面を開きました。",
  "invite.shareFallback": "直接共有できないため、シェア文をコピーしました。",
  "invite.shareFailed": "共有できませんでした。シェア文をコピーしてください。",
  "invite.shareMessage": "30s.to で30秒の自己紹介を作っています。ぜひ試してみてください。\n\n招待コード：\n{codes}\n\n{url} を開いて作成を始めましょう。",
  "invite.recentAria": "招待コードの利用状況",
  "invite.statusTitle": "利用状況",
  "invite.statusSummary": "利用可能 {active} · 使用済み {redeemed} · 期限切れ {expired} · 取消済み {revoked}",
  "invite.status.revoked": "取り消されました",
  "invite.status.redeemed": "使用済み",
  "invite.status.expired": "期限切れ",
  "invite.status.active": "利用可能",
  "invite.copy": "コピー",
  "invite.copied": "コピーされました",
  "invite.showOnce": "一度だけ表示される",
  "invite.expiryUnknown": "有効期限不明",
  "invite.expiresAt": "有効期限は {date} です",
  "management.handlePending.title": "公開URLの変更待ち",
  "management.handlePending.description": "現在のパブリック アドレスは依然として {publishedAddress} です。公開すると、{draftAddress} がアクティブになります。",
  "management.handlePending.next": "{draftAddress} がパブリック アドレスになる前に変更を公開してください。",
  "management.dirty.title": "未公開の変更",
  "management.dirty.description": "あなたのドラフトは公開ページに公開されていません。",
  "management.dirty.next": "変更を公開して公開ページをこのドラフトと同期します。",
  "management.published.title": "発行済み",
  "management.published.description": "公開ページは最新です。",
  "management.published.next": "公開ページは同期されています。調整したい場合は編集を続けてください。",
  "management.unpublished.title": "未公開",
  "management.unpublished.description": "このイントロはまだ下書きとしてのみ保存されています。",
  "management.unpublished.next": "他の人が公開アドレスにアクセスできる前に公開してください。",
  "management.empty.title": "イントロはまだありません",
  "management.empty.description": "アドレスを選択し、30 秒のイントロを書きます。",
  "management.empty.next": "まずドラフトを作成します。公開前チェックはエディターに残ります。",
  "management.publish.create": "紹介文を公開",
  "management.publish.update": "変更を公開する",
  "abuse.kicker": "信頼と安全",
  "abuse.title": "レポートページ",
  "abuse.copy": "報告書は安全性審査のみに使用されます。あなたの身元は公開されていません。",
  "abuse.missingHandle": "レポート対象がありません。",
  "abuse.done": "報告書を受け取りました。すぐにレビューします。",
  "abuse.failed": "提出に失敗しました。後でもう一度試してください。",
  "abuse.reason.spam": "スパム",
  "abuse.reason.impersonation": "なりすまし",
  "abuse.reason.abuse": "ハラスメントまたは嫌がらせ",
  "abuse.reason.illegal": "違法なコンテンツ",
  "abuse.reason.other": "その他の問題",
  "abuse.submitBusy": "送信中...",
  "abuse.submit": "レポートの提出",
  "terms.title": "利用規約",
  "privacy.title": "プライバシーに関する通知",
  "validation.handle.required": "ハンドルを入力してください。",
  "validation.handle.invalid": "ハンドルは 4 ～ 24 文字の小文字の英字である必要があります。",
  "validation.handle.reserved": "この公開アドレスは利用できません。別のものをお試しください。",
  "validation.handle.unavailable": "この公開アドレスは利用できません。別のものをお試しください。",
  "validation.handle.frozen": "この公開アドレスは利用できません。別のものをお試しください。",
  "validation.handle.protected": "この公開アドレスは利用できません。別のものをお試しください。",
  "validation.handle.checkFailed": "このURLを確認できませんでした。",
  "validation.handle.changeLimit": "公開URLは30日に1回だけ変更できます。",
  "validation.displayName.required": "名前またはニックネームは必須です。",
  "validation.identity.required": "一言の肩書きを入力してください。",
  "validation.tags.range": "タグを1〜5個追加してください。",
  "validation.links.limit": "単独リンクは最大{limit}件まで追加できます。",
  "validation.links.empty": "まだリンクはありません。ソーシャル プロフィール、予約ページ、連絡方法を追加できます。",
  "validation.input.tooLong": "入力は{limit}文字以内にしてください。",
  "validation.body.placeholder": "本文に{detail}が残っています。実際の内容に置き換えるか、削除してください。",
  "validation.body.oldTemplate": "以前の本文テンプレート",
  "validation.body.readingTime": "現在の推定は{seconds}秒です。{maximum}秒以内に短くしてください。",
  "validation.body.readingTimeLong": "現在の推定は{seconds}秒で、推奨の{recommended}秒を超えていますが、そのまま公開できます。",
  "validation.body.readingTimeShort": "現在の推定は{seconds}秒です。少なくとも{minimum}秒になるまで内容を追加してみましょう。",
  "validation.markdown.h1": "# ページレベルの見出しはサポートされていません",
  "validation.markdown.deepHeading": "### およびそれより深い見出しはサポートされていません",
  "validation.markdown.image": "画像構文はサポートされていません",
  "validation.markdown.codeBlock": "コードブロックはサポートされていません",
  "validation.markdown.taskList": "タスクリストはサポートされていません",
  "validation.markdown.table": "テーブルはサポートされていません",
  "validation.markdown.footnote": "脚注はサポートされていません",
  "validation.markdown.html": "HTML と埋め込みはサポートされていません",
  "validation.markdown.commentUnclosed": "本文コメントに終了記号 --> がありません",
  "validation.markdown.commentStrayClose": "本文コメントに開始記号 <!-- がありません",
  "validation.markdown.commentNested": "本文コメント <!-- --> は入れ子にできません",
  "validation.markdown.nestedHeading": "セクション見出しは文書のルートに配置してください",
  "validation.markdown.setextHeading": "Setext 見出しはサポートされていません",
  "validation.markdown.headingInline": "セクション見出しにはプレーンテキストのみ使用できます",
  "validation.markdown.frontmatter": "frontmatter はサポートされていません",
  "validation.markdown.indentedCode": "インデントコードブロックは使えません。フェンスコードブロックを使用してください",
  "validation.markdown.codeFenceUnclosed": "コードフェンスの終了記号がありません",
  "validation.markdown.codeLanguage": "言語タグには 1〜32 文字の英数字、_、+、- のみ使用できます",
  "validation.markdown.listDepth": "リストの入れ子は最大3階層です",
  "validation.markdown.tableSize": "表は最大6列、20行です",
  "validation.markdown.linkProtocol": "本文リンクは HTTPS とメールのみ使用できます",
  "validation.link.unsupportedType": "このリンク形式はまだ利用できません。ウェブサイト、対応プラットフォーム、または予約リンクを選んでください。",
  "validation.link.labelRequired": "リンク名を空にすることはできません。",
  "validation.link.providerRequired": "予約プラットフォームを選択してください。",
  "validation.link.valueRequired": "{label} を空にすることはできません。",
  "validation.link.httpsOnly": "リンクは https:// のみ使用できます。",
  "validation.link.invalid": "有効なリンクを入力してください。",
  "validation.link.validEmail": "有効な電子メールを入力してください。",
  "validation.link.validGithub": "有効な GitHub ハンドルを入力してください。",
  "validation.link.validBilibili": "有効な Bilibili UID を入力してください。",
  "validation.link.validXiaohongshu": "有効な小紅書プロフィール リンクを入力してください。",
  "validation.link.validGoogleCalendar": "有効な Google Calendar 予約リンクを入力してください。",
  "validation.link.validMicrosoftBookings": "有効な Microsoft Bookings リンクを入力してください。",
  "validation.theme.proRequired": "このテーマを公開するには、30s Pro が必要です。",
  "validation.link.validHubSpot": "有効な HubSpot Meetings リンクを入力してください。",
  "validation.account.banned": "このアカウントは現在公開できません。",
  "validation.account.login": "まずログインしてください。",
  "validation.account.invite": "先に招待コードでアカウントを有効にしてください。",
  "validation.publish.failed": "公開に失敗しました。後でもう一度試してください。",
  "validation.turnstile.required": "セキュリティチェックを完了してください。",
  "validation.report.missing": "報告するページが指定されていません。",
  "validation.report.reason": "報告理由を選択してください。",
  "validation.report.notReportable": "現在、このページを報告できません。",
  "common.listSeparator": "、",
  "dashboard.section.status": "ステータス",
  "dashboard.section.performance": "パフォーマンス",
  "dashboard.fullAnalytics": "完全な分析を表示",
  "dashboard.shareCard": "シェアカード",
  "dashboard.timestamp.notPublished": "非公開",
  "dashboard.timestamp.notEdited": "未編集",
  "dashboard.timestamp.published": "公開日 {date} UTC",
  "dashboard.timestamp.edited": "編集済み {date} UTC",
  "upgrade.publishTheme": "{theme}を公開",
  "upgrade.copy": "選択内容は保存されています。引き続きすべてのプレビューを確認でき、アップグレード後も編集し直す必要はありません。",
  "upgrade.benefit.themes": "すべてのプレミアムテーマを公開する",
  "upgrade.benefit.analytics": "読書時間と完了を確認する",
  "upgrade.benefit.cards": "ソーシャル OG に同期されたテーマ カード",
  "upgrade.seePro": "30s Proを参照",
  "upgrade.keepEditing": "編集を続ける",
  "pro.meta.title": "30s Pro — もっと自分らしく",
  "pro.meta.description": "プレミアムテーマ、読まれ方の分析、テーマに合う共有カードで、30秒の自己紹介をもっと自分らしく。",
  "pro.title": "自分らしさを、もっと鮮明に。",
  "pro.intro": "読む時間は30秒のまま。Proなら、表現の幅が広がり、反応がより見え、共有素材もすぐに使えます。",
  "pro.priceAction": "Founding Priceを見る",
  "pro.summaryAria": "Proの特典",
  "pro.summaryThemes": "プレミアムテーマ",
  "pro.summaryAnalytics": "日分の分析",
  "pro.summaryShare": "共有カードと連動",
  "pro.benefitsKicker": "Proの機能",
  "pro.benefitsTitle": "伝えるところから、届くところまで。",
  "pro.benefit.themes.title": "プレミアムテーマ",
  "pro.benefit.themes.body": "Terminalをはじめとする8種類。Freeで全テーマを試し、Proで公開できます。",
  "pro.benefit.analytics.title": "読まれ方を分析",
  "pro.benefit.analytics.body": "訪問数だけでなく、有効閲覧時間、完読率、到達位置、30・90・365日の推移、リンクCTRまで確認できます。",
  "pro.benefit.share.title": "自分らしくシェアする",
  "pro.benefit.share.body": "Freeは名前とリンクのシンプルなカード1種。Proでは共通カード2種と各テーマ専用カードが使えます。選んだカードがOG画像にもなり、QR付きで共有・保存できます。",
  "pro.benefit.attribution.title": "主役はあなた",
  "pro.benefit.attribution.body": "通報や言語切替など必要な機能は残しつつ、テーマ内の30s.to表記を非表示にできます。",
  "pro.pricingTitle": "早く始めるほど、ずっとシンプル。",
  "pro.pricingBody": "継続している限り、Founding Priceはそのまま。終了後に再加入する場合は、その時点の価格が適用されます。",
  "pro.terminalAria": "Terminal Pro テーマのプレビュー",
  "pro.checkout.continuous": "継続中は価格を維持",
  "pro.checkout.intervalAria": "支払い周期",
  "pro.checkout.monthly": "月払い",
  "pro.checkout.yearly": "年払い",
  "pro.checkout.save": "$16お得",
  "pro.checkout.periodYear": "年",
  "pro.checkout.periodMonth": "月",
  "pro.checkout.annualNote": "月あたり ${price}。月払いより44%お得です。",
  "pro.checkout.monthlyNote": "月ごとの支払いで、いつでも期間末に解約できます。",
  "pro.checkout.includeThemes": "すべてのプレミアムテーマ",
  "pro.checkout.includeAnalytics": "読まれ方と365日分の分析",
  "pro.checkout.includeCards": "テーマカード、QR、OG",
  "pro.checkout.includeAttribution": "テーマ内の30s.to表記を非表示",
  "pro.checkout.manage": "Proを管理",
  "pro.checkout.comingSoon": "決済は近日公開",
  "pro.checkout.signIn": "ログインしてアップグレード",
  "pro.checkout.inviteRequired": "Beta招待が必要です",
  "pro.checkout.opening": "安全なチェックアウトを開いています…",
  "pro.checkout.upgrade": "30s Pro にアップグレード",
  "pro.checkout.footnote": "決済はCreemが安全に処理します。税額は支払い前に表示され、無料体験なしで自動更新されます。",
  "pro.checkout.unavailable": "現在、決済を開けません。しばらくしてからお試しください。",
  "pro.checkout.networkError": "通信できませんでした。しばらくしてからお試しください。",
  "billing.panelAria": "プロと課金",
  "billing.plan": "プラン",
  "billing.status.canceling": "解約予定",
  "billing.status.pastDue": "支払い期限超過",
  "billing.status.active": "利用中",
  "billing.status.free": "無料",
  "billing.yearly": "毎年",
  "billing.monthly": "毎月",
  "billing.basicPlan": "基本プラン",
  "billing.ends": "終了日：{date}",
  "billing.renews": "次回更新日：{date}",
  "billing.graceEnds": "猶予期間終了: {date}",
  "billing.anomaly": "請求ステータスを手動で確認する必要があります。 support@30s.to までお問い合わせください。",
  "billing.opening": "請求管理を開いています",
  "billing.manage": "請求を管理",
  "billing.upgrade": "プロにアップグレード",
  "billing.openingHistory": "請求履歴を開いています…",
  "billing.viewHistory": "請求履歴を見る",
  "billing.portalUnavailable": "請求管理は一時的に利用できなくなります。",
  "billing.networkError": "ネットワーク接続に失敗しました。もう一度試してください。",
  "billingReturn.kicker": "30s Pro · お支払い確認",
  "billingReturn.activeTitle": "Proを利用できます",
  "billingReturn.failedTitle": "まだ支払いが確認されていません",
  "billingReturn.waitingTitle": "支払いの確認",
  "billingReturn.failedCopy": "お支払いがまだ同期されている可能性があります。後でもう一度ダッシュボードを確認してください。戻りページのみからアクセスが許可されることはありません。",
  "billingReturn.waitingCopy": "支払いプロバイダーにあなたのサブスクリプションを確認しています。このページを開いたままにしておいてください。",
  "billingReturn.back": "管理画面へ戻る",
  "analytics.kicker": "30s Pro · アナリティクス",
  "analytics.nav": "分析",
  "analytics.title": "訪問から、読了まで。",
  "analytics.copy": "個人を追跡せず、訪問から読了・リンク操作までの流れを確認できます。日付と重複排除はUTC基準です。",
  "analytics.rangeAria": "日付範囲",
  "analytics.days": "{count} 日",
  "analytics.uniqueVisitors": "ユニークな訪問者",
  "analytics.rangeTotal": "{count}日間の合計",
  "analytics.averageReading": "平均有効閲覧時間",
  "analytics.activeReadingNote": "画面が表示され、操作対象になっていた時間",
  "analytics.completionRate": "完了率",
  "analytics.completedVisitors": "{count}人が最後まで閲覧",
  "analytics.overallCtr": "全体的なクリック率",
  "analytics.engagedVisitors": "{count}人がリンクを操作",
  "analytics.trafficTrend": "トラフィックの傾向",
  "analytics.dailyTrendAria": "日別ユニーク訪問者の推移",
  "analytics.readingCompletion": "読了状況",
  "analytics.dailyMaximum": "訪問者数 / 1 日の最大数",
  "analytics.visitorCount": "{count} 人の訪問者",
  "analytics.topLinks": "トップリンク",
  "analytics.uniqueClickers": "リンクをクリックした人数",
  "analytics.linkTrendAria": "{label} の毎日の傾向",
  "analytics.noInteractions": "まだリンクインタラクションはありません。",
  "analytics.audienceOverview": "視聴者の概要",
  "analytics.pageLevel": "ページレベル",
  "analytics.referrers": "流入元",
  "analytics.devices": "デバイス",
  "analytics.countries": "国",
  "analytics.noData": "まだデータがありません",
  "analytics.durationSeconds": "{seconds}秒",
  "analytics.durationMinutes": "{minutes}分{seconds}秒",
  "share.card": "シェアカード",
  "share.variant.classic": "クラシック",
  "share.variant.classicNote": "静か",
  "share.variant.contact": "インデックス",
  "share.variant.contactNote": "構造化された",
  "share.variant.theme": "{theme}エディション",
  "share.variant.themeNote": "テーマ",
  "share.variant.universal": "ユニバーサル",
  "share.saveFailed": "保存できませんでした",
  "share.styleUpdated": "スタイルが更新されました",
  "share.networkError": "ネットワーク接続に失敗しました",
  "share.linkCopied": "リンクがコピーされました",
  "share.copyFailed": "コピーに失敗しました",
  "share.text": "私の30秒紹介",
  "share.failed": "共有できませんでした",
  "share.published": "発行済み",
  "share.draft": "草案",
  "share.style": "スタイル",
  "share.alt": "{name} のシェアカード",
  "share.publishFirst": "公開して共有する",
  "share.action": "シェアする",
  "share.download": "ダウンロード",
  "share.openPublicPage": "公開ページを開く",
  "share.chooseStyle": "カードのスタイルを選択してください",
  "share.close": "閉じる",
  "share.cardStyle": "カードスタイル",
  "share.chooseOne": "スタイルを選択してください",
  "share.chooseStyleAria": "シェアカードのスタイルを選択してください",
  "share.saving": "保存",
  "validation.body.placeholderDetail.legacyTemplate": "古い本文テンプレート",
  "validation.body.placeholderDetail.ellipsis": "`...` プレースホルダー",
  "validation.body.placeholderDetail.sampleLink": "サンプルリンク「https://example.com」",
  "validation.body.placeholderDetail.projectName": "`项目名` プレースホルダー",
  "validation.body.placeholderDetail.instruction": "テンプレートの指示テキスト",
  "analytics.gate.signInTitle": "分析を見るにはログイン",
  "analytics.gate.signInCopy": "アクセスとインタラクションのデータは管理画面内で安全に保管されます。",
  "analytics.gate.signInAction": "ログイン",
  "analytics.gate.proTitle": "紹介が最後まで読まれているか確認しましょう。",
  "analytics.gate.proCopy": "有効な読書時間、読了率、進捗分布、30・90・365日の推移、リンクCTRを確認できます。",
  "analytics.gate.proAction": "30s Proを見る",
  "analytics.gate.emptyTitle": "公開後、ここにデータが表示されます。",
  "analytics.gate.emptyCopy": "まず30秒の紹介を完成させましょう。公開後にアクセスとインタラクションの推移を確認できます。",
  "analytics.gate.emptyAction": "作成を始める",
  "analytics.gate.privacyNote": "UTC日次集計 · 匿名で重複排除 · 元のIPアドレスは保存しません",
  "handleEdit.previous": "保護中の旧アドレス",
  "handleEdit.deadlines": "転送終了：{redirectDate}、保護終了：{releaseDate}。",
  "handleEdit.usePrevious": "このアドレスを使う",
  "handleEdit.reclaimAvailable": "この旧アドレスを再取得できます。",
  "publish.handleReclaimed": "再取得もアドレス変更として扱われます。現在のアドレスには新たに30日間の転送と180日間の保護が適用されます。"
}
